import { cookieNames } from 'sdk-ui-web-library-common'
import { getCookie } from './cookieHelper'

export function isAuthenticatedWithCrossDomain() {
  const parkFrAccess = getCookie(cookieNames.PARK_FR_ACCESS)
  const parkFrRefresh = getCookie(cookieNames.PARK_FR_REFRESH)
  return parkFrAccess || parkFrRefresh
}
